module.exports = __webpack_public_path__ + "img/header_bg.82a0d597.png";